export const COLORS = {
  red: '#C82E34',
  blue: '#5182ff',
};
